import { z } from 'zod';
const NewsletterValidationSchema = z.object({
    Email: z.string().email()
});
// Lenient schema for inbound Intercom webhooks: validates only consumed fields and allows unknown keys.
const IntercomWebhookSchema = z.object({
    topic: z.string(),
    id: z.string().optional(),
    delivery_attempts: z.number().optional(),
    data: z
        .object({
        item: z
            .object({
            id: z.string().optional(),
            external_id: z.string().nullish()
        })
            .optional()
    })
        .optional()
});
const CONTACT_SUBJECTS = [
    'general_inquiry',
    'media_inquiry',
    'partnership',
    'technical_support',
    'feedback',
    'other'
];
const CONTACT_SUBJECT_LABELS = {
    general_inquiry: 'General inquiry',
    media_inquiry: 'Media inquiry',
    partnership: 'Partnership',
    technical_support: 'Technical support',
    feedback: 'Feedback',
    other: 'Other'
};
const ContactFormValidationSchema = z.object({
    name: z.string().trim().min(1).max(100),
    email: z.string().trim().email(),
    organization: z.string().trim().max(200).optional(),
    subject: z.enum(CONTACT_SUBJECTS),
    message: z.string().trim().min(1).max(5000)
});
export { CONTACT_SUBJECTS, CONTACT_SUBJECT_LABELS, ContactFormValidationSchema, IntercomWebhookSchema, NewsletterValidationSchema };
//# sourceMappingURL=services.js.map